/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Agent_Release_LinkInputs */

const en_mk_agent_release_link = /** @type {(inputs: Mk_Agent_Release_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New: agent teams, AI choices, and Desktop`)
};

const id_mk_agent_release_link = /** @type {(inputs: Mk_Agent_Release_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baru: tim agent, pilihan AI, dan Desktop`)
};

/**
* | output |
* | --- |
* | "New: agent teams, AI choices, and Desktop" |
*
* @param {Mk_Agent_Release_LinkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_agent_release_link = /** @type {((inputs?: Mk_Agent_Release_LinkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Agent_Release_LinkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_agent_release_link(inputs)
	return en_mk_agent_release_link(inputs)
});